import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const PrinterCreate_UpdateSlice = createSlice({
  name: "PrinterCreate_UpdateSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    printerCreate_Update: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successPrinterCreate_Update: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurePrinterCreate_Update: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearPrinterCreate_Update: (state) => {
      state.data = {};
    },
  },
});

export const {
  printerCreate_Update,
  failurePrinterCreate_Update,
  successPrinterCreate_Update,
  clearPrinterCreate_Update,
} = PrinterCreate_UpdateSlice.actions;

export default PrinterCreate_UpdateSlice.reducer;
